import PropTypes from "prop-types"
import React from "react"

const DateField = ({ label, value }) => (
  <div>
    <h3 className="m-0 text-xxs uppercase tracking-wide text-gray-500">
      {label}
    </h3>
    <p className="mb-0 mt-1 text-center text-sm font-semibold text-gray-900">
      {value ?? "—"}
    </p>
  </div>
)

DateField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
}

const DatesSection = ({
  createdAt,
  scheduledAt,
  workStartedAt,
  closedAt,
  timeToClose,
}) => (
  <div className="flex flex-wrap justify-between gap-y-4 border-t pt-4">
    <DateField label="Created" value={createdAt} />
    <DateField label="Scheduled" value={scheduledAt} />
    <DateField label="Work Started" value={workStartedAt} />
    <DateField label="Closed" value={closedAt} />
    <DateField label="Time to Close" value={timeToClose} />
  </div>
)

DatesSection.propTypes = {
  createdAt: PropTypes.string,
  scheduledAt: PropTypes.string,
  workStartedAt: PropTypes.string,
  closedAt: PropTypes.string,
  timeToClose: PropTypes.string,
}

export default DatesSection
